import styled, { css } from 'styled-components';

const bgProps = ({ light = false, background, theme }) => css`
  background-color: ${theme.base.colorSchema[background] || theme.base.colorSchema.white};
  opacity: ${light ? 0.5 : 1};
  &:hover {
    background-color: ${theme.base.colorSchema[background] || theme.base.colorSchema.primary100};
  }
`;

const StyledItem = styled.div`
  position: relative;
  padding: 0.8rem 1.6rem;
  border-bottom: 1px solid var(--greyMouse);

  .showOnHover {
    display: none;
  }

  &:hover .showOnHover {
    display: block;
  }

  ${bgProps};
`;

export default StyledItem;
